// extracted by mini-css-extract-plugin
export default {"subtitle":"HomeCatalog_subtitle__65EMe","grid":"HomeCatalog_grid__SfUsl","empty":"HomeCatalog_empty__l2I1M"};